<template>
    <div id="operationLog" class="capacity-flow-manage">
        <SideNav></SideNav>
        <div class="gr-content-container">
            <top-header>
                <div slot="setup-header-left" class="setup-header-left">
                    <span class="setup-header-left-icon">
                        <i class="el-icon-document"></i>
                    </span>
                    <span>{{ $t('operationLog.title') }}</span>
                </div>
            </top-header>
            <div class="content">
                <div class="manage-nav-section">
                    <ManangeNav></ManangeNav>
                </div>
                <div class="content-section">
                    <div class="operation-log-content-box">
                        <div class="filter-row">
                            <el-input
                                v-model="query.moduleName"
                                size="small"
                                clearable
                                :placeholder="$t('operationLog.moduleNamePlaceholder')"
                                @keyup.enter.native="handleSearch"
                            ></el-input>
                            <el-input
                                v-model="query.keyword"
                                size="small"
                                clearable
                                :placeholder="$t('operationLog.keywordPlaceholder')"
                                @keyup.enter.native="handleSearch"
                            ></el-input>
                            <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">
                                {{ $t('operationLog.search') }}
                            </el-button>
                            <el-button size="small" icon="el-icon-refresh-left" @click="handleReset">
                                {{ $t('operationLog.reset') }}
                            </el-button>
                            <el-button size="small" icon="el-icon-refresh" @click="fetchData"></el-button>
                        </div>

                        <div class="table-container">
                            <el-table
                                :data="logs"
                                style="width: 100%"
                                height="100%"
                                v-loading="loading"
                                border
                            >
                                <el-table-column prop="userAccount" :label="$t('operationLog.userAccount')" width="160" show-overflow-tooltip align="center"></el-table-column>
                                <el-table-column prop="userName" :label="$t('operationLog.userName')" width="140" show-overflow-tooltip align="center"></el-table-column>
                                <el-table-column prop="moduleName" :label="$t('operationLog.moduleName')" width="160" show-overflow-tooltip align="center"></el-table-column>
                                <el-table-column prop="operationType" :label="$t('operationLog.operationType')" width="130" show-overflow-tooltip align="center"></el-table-column>
                                <el-table-column prop="operationName" :label="$t('operationLog.operationName')" min-width="180" show-overflow-tooltip align="center"></el-table-column>
                                <el-table-column :label="$t('operationLog.createDate')" width="170" show-overflow-tooltip align="center">
                                    <template slot-scope="scope">
                                        {{ formatCreateTime(scope.row.createTime || scope.row.createDate) }}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('operationLog.requestParams')" min-width="240" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ formatParamsInline(scope.row.requestParams) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('operationLog.operate')" width="100" fixed="right" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="showParams(scope.row)">
                                            {{ $t('operationLog.detail') }}
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <div class="pagination-container">
                            <el-pagination
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                :current-page="pageNo"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-drawer
            :title="$t('operationLog.paramsDetail')"
            :visible.sync="drawerVisible"
            size="50%"
            direction="rtl"
            append-to-body
        >
            <div class="detail-drawer-content">
                <pre class="params-pre">{{ activeParams }}</pre>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import TopHeader from "../../../components/top-header.vue";
import SideNav from "../../menu/SideNav.vue";
import ManangeNav from "../../menu/ManageNave.vue";

export default {
    name: "operationLog",
    components: {
        TopHeader,
        SideNav,
        ManangeNav,
    },
    data() {
        return {
            loading: false,
            drawerVisible: false,
            activeParams: "",
            logs: [],
            pageNo: 1,
            pageSize: 20,
            total: 0,
            query: {
                moduleName: "",
                keyword: "",
            },
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.loading = true;
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                moduleName: this.query.moduleName,
                keyword: this.query.keyword,
            };

            this.$http
                .get(this.requestUrl.operationLog.page, { params })
                .then((res) => {
                    if (res.data && res.data.code === "0") {
                        const data = res.data.data || {};
                        this.logs = data.list || [];
                        this.total = data.total || 0;
                    } else {
                        this.$message.error((res.data && res.data.message) || this.$t('operationLog.fetchFail'));
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(this.$t('operationLog.networkError'));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.pageNo = 1;
            this.fetchData();
        },
        handleReset() {
            this.query = {
                moduleName: "",
                keyword: "",
            };
            this.pageNo = 1;
            this.fetchData();
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.fetchData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.fetchData();
        },
        showParams(row) {
            this.activeParams = this.formatParams(row.requestParams);
            this.drawerVisible = true;
        },
        formatParamsInline(value) {
            const params = this.formatParams(value);
            return params === "-" ? params : params.replace(/\s+/g, " ");
        },
        formatParams(value) {
            if (value === null || value === undefined || value === "") {
                return "-";
            }
            if (typeof value === "object") {
                return JSON.stringify(value, null, 2);
            }
            try {
                return JSON.stringify(JSON.parse(value), null, 2);
            } catch (e) {
                return String(value);
            }
        },
        formatCreateTime(value) {
            if (!value) {
                return "-";
            }
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return value;
            }
            const utc8Time = new Date(date.getTime() + 8 * 60 * 60 * 1000);
            const pad = (num) => String(num).padStart(2, "0");
            return `${utc8Time.getUTCFullYear()}-${pad(utc8Time.getUTCMonth() + 1)}-${pad(utc8Time.getUTCDate())} ${pad(utc8Time.getUTCHours())}:${pad(utc8Time.getUTCMinutes())}:${pad(utc8Time.getUTCSeconds())}`;
        },
    },
};
</script>

<style lang="less" scoped>
@import "./../../../assets/less/capacityAndFlowManage/capacityFlowManage.less";

.capacity-flow-manage {
    .content-section {
        .operation-log-content-box {
            padding: 16px;
            height: 100%;
            display: flex;
            flex-direction: column;
            background-color: #f5f8fb;

            .filter-row {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 10px;
                margin-bottom: 16px;

                .el-input {
                    width: 220px;
                }
            }

            .table-container {
                flex: 1;
                min-height: 0;
                background-color: #fff;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            }

            .pagination-container {
                padding: 12px 0;
                text-align: right;
            }
        }
    }
}

.detail-drawer-content {
    padding: 20px;
    height: calc(100vh - 80px);
    overflow-y: auto;

    .params-pre {
        margin: 0;
        min-height: 100%;
        background: #1e1e1e;
        color: #dcdcdc;
        padding: 16px;
        border-radius: 6px;
        font-family: "Fira Code", Consolas, monospace;
        font-size: 12px;
        line-height: 1.6;
        overflow-x: auto;
        white-space: pre-wrap;
        word-break: break-word;
    }
}
</style>
